module.exports = __webpack_public_path__ + "static/media/ico_logo_dk.a8aea59e.svg";